import(/* webpackMode: "eager", webpackExports: ["CartButton"] */ "/opt/buildhome/repo/app/components/CartButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LanguageToggle"] */ "/opt/buildhome/repo/app/components/LanguageToggle.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MegaMenu"] */ "/opt/buildhome/repo/app/components/MegaMenu.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MobileMenu"] */ "/opt/buildhome/repo/app/components/MobileMenu.tsx");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/node_modules/next/dist/client/app-dir/link.js");
